/**
 * FleetLocate login UI applies under /spireon/* auth login routes (SpireonNew).
 */
export const isSpireonFleetLocateLogin = (pathname = window.location.pathname) =>
  window.$environment?.SERVICE_PROVIDER === 'spireon' &&
  pathname.indexOf('/spireon') >= 0 &&
  pathname.includes('/auth/login');

export const fleetLocateLoginPageConfig = {
  name: 'pages/web/Login/FleetLocateComponent',
  props: ['apiStatus', 'login', 'fetchLogin'],
  commonProps: ['Styled', 'i18n', 'history'],
  hasRegistration: false,
  innerComponent: 'pages/web/Login/FleetLocateRenderComponent',
};

/** Default authenticated landing route for SpireonNew (e.g. /spireon/summary). */
export const getSpireonNewDefaultRoute = () => '/spireon/summary';

export const resolveSpireonNewPostLoginPath = (referrer) =>
  referrer && String(referrer).startsWith('/spireon') ? referrer : getSpireonNewDefaultRoute();

/** Use SpireonNew /spireon/* routes after login from the FleetLocate login page or /spireon/* URLs. */
export const shouldUseSpireonNewRoutes = (pathname = window.location.pathname) =>
  isSpireonFleetLocateLogin(pathname) ||
  window.$environment?.CURRENT_LAYOUT === 'SpireonNew' ||
  (window.$environment?.SERVICE_PROVIDER === 'spireon' && pathname.indexOf('/spireon') >= 0);
